import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from './Header';

const NotFound = () => {
    const navigate = useNavigate();
    
    return (
        <div className="not-found-page">
            <Header />
            
            <div className="not-found-container">
                <Container>
                    <Row className="justify-content-center align-items-center min-vh-80">
                        <Col lg={8} className="text-center">
                            <div className="not-found-content">
                                <div className="error-code">404</div>
                                <h1 className="error-title">Page Not Found</h1>
                                <p className="error-message">
                                    Looks like you've wandered off the path. The page you're looking for doesn't exist.
                                </p>
                                <div className="error-actions">
                                    <Button 
                                        className="home-btn" 
                                        size="lg"
                                        onClick={() => navigate('/')}
                                    >
                                        Go Home
                                    </Button>
                                    <Button 
                                        variant="outline-primary" 
                                        size="lg"
                                        onClick={() => navigate(-1)}
                                    >
                                        Go Back
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default NotFound;
